import React, { useState, useEffect } from "react";
import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../../../firebase-config";
import {
    Box,
    Typography,
    Grid,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";

export default function EmploymentChart() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [categories, setCategories] = useState([]);
    const [total, setTotal] = useState([]);
    const [privateSector, setPrivateSector] = useState([]);
    const [publicSector, setPublicSector] = useState([]);

    async function getData({ country }) {
        setLoading(true);
        const q = query(
            collection(db, "employment"),
            where("country", "==", country),
            orderBy("year"),
        );
        const allDocs = [];
        const totalEmployment = [];
        const privSector = [];
        const pubSector = [];
        const cats = [];

        const querySnapshot = await getDocs(q);

        querySnapshot.forEach((doc) => {
            const docData = doc.data();
            allDocs.push(docData);
            totalEmployment.push(docData["total"]);
            privSector.push(docData["private-sector"]);
            pubSector.push(docData["public-sector"]);
            cats.push(docData["year"]);
        });

        setData(allDocs);
        setCategories(cats);
        setTotal(totalEmployment);
        setPrivateSector(privSector);
        setPublicSector(pubSector);
        setLoading(false);
    }

    useEffect(() => {
        getData({ country: "Kenya" });
    }, []);

    return loading ? (
        <Typography variant="h4" align="center">
            Loading ...
        </Typography>
    ) : data.length !== 0 ? (
        <Box
            sx={{
                mt: "10px",
            }}
        >
            <Typography variant="h4" align="center">
                Kenya's Employment Data
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <ReactApexChart
                        options={{
                            theme: {
                                mode: "dark",
                            },
                            title: {
                                text: "Employment Data",
                                align: "center",
                                style: {
                                    fontSize: "15px",
                                    //   color: "#666",
                                },
                            },
                            chart: {
                                type: "bar",
                                height: 500,
                            },
                            plotOptions: {
                                bar: {
                                    horizontal: false,
                                },
                            },
                            dataLabels: {
                                enabled: false,
                                formatter: function (value) {
                                    return "Ksh. " + value.toLocaleString();
                                },
                            },
                            yaxis: {
                                labels: {
                                    formatter: function (value) {
                                        return "Ksh. " + value.toLocaleString();
                                    },
                                },
                            },
                            tooltip: {
                                shared: true,
                                intersect: false,
                            },
                            stroke: {
                                show: true,
                                // width: 0.5,
                                colors: ["#fff"],
                            },
                            xaxis: {
                                categories: categories,
                            },
                        }}
                        series={[
                            {
                                name: "Total",
                                data: total,
                            },
                            {
                                name: "Private Sector",
                                data: privateSector,
                            },

                            {
                                name: "Public Sector",
                                data: publicSector,
                            },
                        ]}
                        height={500}
                        type="bar"
                    />
                </Grid>
            </Grid>
        </Box>
    ) : (
        <Typography variant="h4" align="center">
            Sorry, No Data Available
        </Typography>
    );
}
